module.exports = __webpack_public_path__ + "static/media/img_history_school.db249380.svg";